import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "../../../HOC/CreateAxios/CreateAxios";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import storage from "../../../HOC/FIREBASE/FIREBASE.jsx";
import Table from "../../UI/Table/Table";
import { MdAdd, MdDelete } from "react-icons/md";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function AddProduct({ setShowProduct }) {
  // form names and keys for mapping
  const [Description, setDescription] = useState("");
  const [progress, setprogress] = useState(0);
  const [progressShow, setprogressShow] = useState(false);
  const Navigate = useNavigate();
  const [brand, setBrand] = useState([]);
  const [category, setCategory] = useState([]);
  const [show, setShow] = useState(false);
  const [ID, setID] = useState("");
  const [Tbody, setTbody] = useState([]);
  const [storeImage, setStoreImage] = useState("");

  const formats = [
    "header",
    "fonts",
    "size",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
    "image",
    "video",
  ];
  const modules = {
    toolbar: [
      [
        { header: "1" },
        { header: "2" },
        { header: [3, 4, 5] },
        {
          font: [],
        },
      ],
      [{ size: [] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image", "video"],
      ["clear"],
    ],
  };
  const Thead = [
    { title: "s.nO" },
    { title: "unit" },
    { title: "price" },
    { title: "action" },
  ];
  // const Tbody = [{ price: "300", unit: "ml" }];
  const getBrand = () => {
    try {
      axios
        .get("/brand")
        .then((res) => {
          console.log(res);
          setBrand(res.data.Brand);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getBrand();
  }, []);
  let BrandOptions = [];
  brand?.map((val, i) => {
    let storeBrandData = {
      id: val.id,
      value: val.Brand_name,
    };
    BrandOptions.push(storeBrandData);
  });
  const getCategory = () => {
    axios
      .get("/category")
      .then((res) => {
        console.log(res);
        setCategory(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getCategory();
  }, []);
  let CategoryOptions = [];

  category?.map((val, i) => {
    let store = {
      id: val.id,
      value: val.Category_name,
    };
    console.log(store);
    CategoryOptions.push(store);
  });

  const FormInitial = [
    {
      label: "Product Name",
      apiKey: "product_name",
      placeholder: "Enter product name  ",
      type: "text",
    },
    {
      label: "Brand",
      apiKey: "product_brand",
      type: "select",
      options: [{ value: "Select brand", id: "0" }, ...BrandOptions],
    },
    {
      label: "Category",
      apiKey: "product_category",
      type: "select",
      options: [{ value: "Select category", id: "0" }, ...CategoryOptions],
    },

    {
      label: "Quantity",
      apiKey: "product_quantity",
      placeholder: "Enter product quantity ",
      type: "number",
    },
  ];
  const FormDetas = [
    {
      label: "Unit",
      apiKey: "unit",
      placeholder: "Enter product unit ",
      type: "text",
    },
    {
      label: "Price",
      apiKey: "price",
      placeholder: "In R.s",
      type: "number",
    },
  ];

  const Submit = async (val) => {
    console.log(val, Description, storeImage, Tbody);
    // let priceandunit = [];
    // val.priceandunit.map((value, i) => {
    //   let store = { price: val.price, unit: val.unit };
    //   return priceandunit.push(store);
    // });
    // console.log(priceandunit);

    try {
      let formData = new FormData();
      await formData.append("product_name", val.product_name);
      await formData.append("product_category", val.product_category);
      await formData.append("product_brand", val.product_brand);
      await formData.append("product_quantity", val.product_quantity);
      await formData.append("desc", Description);
      Tbody?.map((val, i) => {
        formData.append("priceandunit[]", JSON.stringify(val));
      });
      await formData.append("image", storeImage);
      axios
        .post("/product", formData)
        .then((res) => {
          if (res.status === 200) {
            setprogressShow(true);
            setStoreImage("");
            setDescription("");
            setTbody([]);
            toast.success("Product has been added sucessfully");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };
  let Spinner;
  if (progressShow) {
    Spinner = (
      <div
        style={{ background: "rgba(0,0,0,.5)" }}
        className="fixed h-screen w-screen top-0 left-0 z-50 flex items-center justify-center"
      >
        <div className="h-44 w-44  rounded-md z-50">
          <CircularProgressbar value={progress} text={`${progress}%`} />
        </div>
      </div>
    );
  }
  const SubmitValuesInTable = (value, resetForm) => {
    setShow(true);
    // console.log(value, Tbody);
    setTbody([...Tbody, value]);
    resetForm();
  };

  const DeleteTableData = (id) => {
    Tbody.splice(id, 1);
    setTbody([...Tbody]);
  };
  const ProductSchema = yup.object().shape({
    product_name: yup.string().required("Product name is required"),
    price: yup.string().required("Product price is required"),
    unit: yup.string().required("Product unit is required"),
    product_quantity: yup.string().required("Product quantity is required"),
    product_category: yup
      .string()
      .required("Product category unit is required"),
    product_brand: yup.string().required("Product brand unit is required"),
  });
  const ProductSchemas = yup.object().shape({
    price: yup.string().required("Product price is required"),
    unit: yup.string().required("Product unit is required"),
  });
  const handleImage = (e) => {
    if (e.target.files.length !== 0) {
      // setStoreImage([...storeImage, e.target.files[0]]);
      setStoreImage(e.target.files[0]);
    }
  };
  return (
    <div className="p-6">
      <ToastContainer />
      {/* form is done here */}
      <div>
        <Formik
          initialValues={{
            image: "",
            priceandunit: "",
            product_name: "",
            product_quantity: "",
            product_category: "",
            product_brand: "",
            desc: "",

            // image: null,
          }}
          // validationSchema={ProductSchema}
          onSubmit={(values, { resetForm }) => {
            console.log(values);
            Submit(values);
            resetForm();
          }}
        >
          {({ errors, touched, handleSubmit, values, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div className="grid laptop:grid-cols-2 laptop:gap-8">
                  <div>
                    {FormInitial &&
                      FormInitial?.map((val, i) => {
                        if (val.type === "select") {
                          return (
                            <div key={i} className="flex flex-col space-y-2">
                              <label className="px-1 mt-2 poppins font-medium">
                                {val.label}
                              </label>
                              <Field
                                name={val.apiKey}
                                as={val.type}
                                // placeholder={"Enter product name"}
                                className="border py-2 px-1 font-normal outline-none capitalize default:text-gray-300"
                              >
                                {val.options?.map((val, i) => {
                                  return (
                                    <option
                                      className={`capitalize ${
                                        val.id === "0" ? "text-gray-300" : ""
                                      }`}
                                      key={i}
                                      value={val.id}
                                    >
                                      {val.value}
                                    </option>
                                  );
                                })}
                              </Field>
                              <div
                                className={`${
                                  errors[val.apiKey] && touched[val.apiKey]
                                    ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                                    : ""
                                }`}
                              >
                                {errors[val.apiKey] && touched[val.apiKey]
                                  ? errors[val.apiKey]
                                  : ""}
                              </div>
                            </div>
                          );
                        } else {
                          return (
                            <div key={i} className="flex flex-col space-y-2">
                              <label className="px-1  mt-2 poppins font-medium">
                                {val.label}
                              </label>
                              <Field
                                name={val.apiKey}
                                type="text"
                                placeholder={val.placeholder}
                                className="border py-2 px-1 "
                              />
                              {/* <div
                                className={`${
                                  errors[val.apiKey] && touched[val.apiKey]
                                    ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                                    : ""
                                }`}
                              >
                                {errors[val.apiKey] && touched[val.apiKey]
                                  ? errors[val.apiKey]
                                  : ""}
                              </div> */}
                            </div>
                          );
                        }
                        // }
                      })}
                  </div>
                  <div className="">
                    <Formik
                      initialValues={{
                        price: "",
                        unit: "",
                      }}
                      // validationSchema={ProductSchemas}
                      onSubmit={(values, { resetForm }) => {
                        console.log(values);
                        SubmitValuesInTable(values, resetForm);
                      }}
                    >
                      {({ values, errors, touched, handleSubmit }) => {
                        return (
                          <Form>
                            <div>
                              {FormDetas &&
                                FormDetas?.map((val, i) => {
                                  return (
                                    <div
                                      key={i}
                                      className="flex flex-col space-y-2"
                                    >
                                      <label className="px-1 mt-2 poppins font-medium">
                                        {val.label}
                                      </label>
                                      <Field
                                        name={val.apiKey}
                                        type={val.type}
                                        placeholder={val.placeholder}
                                        className="border py-2 px-1 "
                                      />
                                      {/* <div
                                        className={`${
                                          errors[val.apiKey] &&
                                          touched[val.apiKey]
                                            ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                                            : ""
                                        }`}
                                      >
                                        {errors[val.apiKey] &&
                                        touched[val.apiKey]
                                          ? errors[val.apiKey]
                                          : ""}
                                      </div> */}
                                    </div>
                                  );
                                })}
                              <div className=" flex justify-end my-1">
                                <button
                                  type={"button"}
                                  onClick={handleSubmit}
                                  className="w-20 h-[40px] capitalize font-medium bg-yellow-500  p- text-white"
                                >
                                  add
                                </button>
                              </div>
                              <div className="">
                                <div className="px-1 mt-3 mb-2 poppins font-medium capitalize">
                                  details of price and unit
                                </div>

                                {Tbody.length > 0 ? (
                                  <Table Head={Thead} height="productHeight">
                                    {Tbody?.map((val, i) => {
                                      return (
                                        <tr
                                          key={i}
                                          className="  font-semibold border border-gray-200 text-gray-600"
                                          align="center "
                                        >
                                          <td>
                                            <div className="my-2">{i + 1}</div>
                                          </td>
                                          <td>{show ? val.unit : ""}</td>
                                          <td>{show ? val.price : ""}</td>
                                          <td>
                                            <button
                                              type="button"
                                              onClick={() => DeleteTableData(i)}
                                            >
                                              <MdDelete className="w-5 h-5" />
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </Table>
                                ) : (
                                  <div className="">
                                    <Table
                                      Head={Thead}
                                      height="no data in form"
                                    ></Table>
                                    <div className="text-xl flex   justify-center items-center  h-20">
                                      No table data available yet!
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
                <div className="grid grid-cols-1 laptop:grid-cols-2 gap-8">
                  {/* for image */}
                  <div className="mt-4 w-full flex flex-col">
                    <label htmlFor="image" className="poppins font-medium pb-2">
                      Product Image
                    </label>
                    <label
                      htmlFor="image"
                      className="poppins font-medium bg-GrayLight h-full w-full border"
                    >
                      <img
                        src={
                          storeImage.length === 0
                            ? "https://images.unsplash.com/photo-1660039031080-7779c1760a0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
                            : URL.createObjectURL(storeImage)
                        }
                        alt="productimage"
                        className="h-72 mx-auto cursor-pointer"
                      />
                    </label>
                    <input
                      id={"image"}
                      name={"image"}
                      type="file"
                      accept=".gif,.jpg,.jpeg,.png,"
                      className="border-2 p-3 w-full outline-none mt-1"
                      onChange={(e) => {
                        handleImage(e);
                      }}
                    />
                  </div>
                  {/* description tag is here */}

                  <div className="mt-4 w-full flex flex-col">
                    <label htmlFor="image" className="poppins font-medium pb-2">
                      Product Desription
                    </label>
                    <ReactQuill
                      style={{
                        height: "200px !important",
                        border: `none !important`,
                      }}
                      className="fold:w-11/12 h-[280px] quill-container  "
                      modules={modules}
                      formats={formats}
                      value={Description}
                      onChange={(val) => {
                        setDescription(val);
                      }}
                    />
                  </div>
                </div>
                <div className="w-full  mt-10  tablet:mt-16">
                  <button
                    type="submit"
                    className="px-8 py-2 bg-green-600 text-white rounded-sm shadow-md cursor-pointer"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}
export default AddProduct;
